import { StylesConfig } from 'react-select';
import { CURRENCY } from '../../../shared/enums/currency.enum';

export const CONTENT_CLASS = 'max-w-[1440px] mx-auto px-[clamp(16px,3vw,48px)]';
export const SECTION_CLASS = 'py-[40px] scroll-mt-[72px]';
export const SECTION_TITLE =
  'm-0 mb-[20px] text-[clamp(18px,1.5vw,22px)] font-gilroy-bold text-neutral-500';
export const FIELD =
  'h-[40px] w-full rounded-[10px] border border-gray-200 bg-neutral-0 px-[12px] text-[15px] text-neutral-500 hover:border-neutral-500 focus:border-neutral-500 outline-none transition-colors';
export const LABEL = 'flex flex-col gap-[6px] text-[12px] font-gilroy-medium text-neutral-300';
export const CHECKBOX_LABEL =
  'flex items-center gap-[8px] text-[14px] text-neutral-500 cursor-pointer';
export const PRIMARY_BUTTON =
  'h-[44px] inline-flex items-center justify-center gap-[6px] px-[16px] rounded-[12px] bg-primary-500 text-neutral-0 text-[14px] font-gilroy-medium hover:bg-primary-600 cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed';
export const SECONDARY_BUTTON =
  'h-[44px] inline-flex items-center gap-[6px] px-[16px] rounded-[12px] border border-gray-200 bg-neutral-0 text-[14px] font-gilroy-medium text-neutral-500 hover:border-neutral-500 transition-colors cursor-pointer whitespace-nowrap';
export const OUTLINE_BUTTON =
  'h-[40px] inline-flex items-center gap-[8px] px-[16px] rounded-[8px] border border-neutral-500 bg-neutral-0 text-[14px] font-gilroy-medium text-neutral-500 hover:bg-creams-200 cursor-pointer whitespace-nowrap disabled:border-gray-200 disabled:text-neutral-100 disabled:hover:bg-neutral-0 disabled:cursor-not-allowed';
export const LINK_BUTTON =
  'p-0 bg-transparent border-0 text-[14px] font-gilroy-medium text-neutral-500 underline underline-offset-[3px] cursor-pointer';
export const TH =
  'px-[16px] py-[12px] text-left text-[12px] font-gilroy-medium text-neutral-300 whitespace-nowrap';
export const TD = 'px-[16px] py-[14px] text-[14px] text-neutral-500 whitespace-nowrap align-middle';
export const CHIP =
  'inline-flex items-center rounded-full px-[10px] py-[3px] text-[12px] font-gilroy-medium whitespace-nowrap';
export const EMPTY_STATE =
  'rounded-[16px] bg-creams-100 px-[24px] py-[32px] text-center text-[15px] text-neutral-300';

export const selectStyles: StylesConfig<any, boolean> = {
  control: (base, state) => ({
    ...base,
    minHeight: '40px',
    borderRadius: '10px',
    borderColor: state.isFocused ? '#292a2b' : '#e6e8ec',
    boxShadow: 'none',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    '&:hover': { borderColor: '#292a2b' }
  }),
  valueContainer: (base) => ({ ...base, padding: '0 12px' }),
  singleValue: (base) => ({ ...base, fontSize: '15px', color: '#292a2b' }),
  multiValue: (base) => ({ ...base, borderRadius: '8px', backgroundColor: '#faf8f6' }),
  multiValueLabel: (base) => ({ ...base, fontSize: '13px', color: '#292a2b' }),
  placeholder: (base) => ({ ...base, fontSize: '15px' }),
  input: (base) => ({ ...base, fontSize: '15px' }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({ ...base, padding: '0 10px 0 4px', color: '#707071' }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({
    ...base,
    marginTop: '6px',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid #e6e8ec',
    boxShadow: '0px 2px 6px 2px rgba(0,0,0,0.08)'
  }),
  menuList: (base) => ({ ...base, padding: '6px' }),
  option: (base, state) => ({
    ...base,
    borderRadius: '8px',
    fontSize: '14px',
    fontFamily: state.isSelected ? 'Gilroy-Medium' : 'Gilroy-Regular',
    color: '#292a2b',
    backgroundColor: state.isSelected ? '#f8f4f1' : state.isFocused ? '#faf8f6' : 'transparent',
    cursor: 'pointer'
  })
};

export const selectProps = {
  styles: selectStyles,
  menuPortalTarget: document.body,
  menuPlacement: 'auto' as const
};

export const formatMoney = (value: number, currency?: string) => {
  const key = (currency || 'egp').toLowerCase() as keyof typeof CURRENCY;
  return `${CURRENCY[key] || 'EGP'} ${Math.round(value).toLocaleString('en-US')}`;
};
